import React from 'react';

import { Grid, Backdrop, CircularProgress, Typography } from '@mui/material';

import { COLOR_PRIMARY } from 'src/const';

const FullScreenCircularLoader = ({ message }: { message: string }) => {
  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={true}>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <CircularProgress sx={{ color: COLOR_PRIMARY }} />
          <Typography sx={{ marginTop: 2, fontWeight: 500 }} variant="body1">
            {message}
          </Typography>
        </Grid>
      </Backdrop>
    </div>
  );
};

export default FullScreenCircularLoader;
